"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const concat_1 = tslib_1.__importDefault(require("lodash/concat"));
const __elasticsearch_1 = require("../../../../__elasticsearch");
const __enums_1 = require("../../../../__types/__enums");
const getElasticsearchQueryFromFilters_1 = require("../../../__common/elasticsearchQuery/getElasticsearchQueryFromFilters");
const StateMetricAggregation = {
    totalCount: {
        sum: {
            script: '1'
        }
    },
    checkpoint: {
        filter: {
            term: {
                contentType: __enums_1.ContentTypeEnum.CHECKPOINT
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    liveTraining: {
        filter: {
            term: {
                contentType: __enums_1.ContentTypeEnum.ILT
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    offer: {
        filter: {
            term: {
                contentType: __enums_1.ContentTypeEnum.OFFER
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    curriculumOffer: {
        filter: {
            term: {
                contentType: __enums_1.ContentTypeEnum.CURRICULUM_OFFER
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    complete: {
        filter: {
            term: {
                completionStatus: __enums_1.CompletionStatusValuesEnum.COMPLETED
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    inProgress: {
        filter: {
            term: {
                completionStatus: __enums_1.CompletionStatusValuesEnum.INCOMPLETE
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    notStarted: {
        filter: {
            term: {
                completionStatus: __enums_1.CompletionStatusValuesEnum.NOT_ATTEMPTED
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    overdue: {
        filter: {
            bool: {
                must_not: [
                    {
                        term: {
                            completionStatus: __enums_1.CompletionStatusValuesEnum.COMPLETED
                        }
                    },
                    {
                        term: {
                            'currentEnrolmentInfo.dueDate': -1
                        }
                    }
                ],
                must: [
                    {
                        exists: {
                            field: 'currentEnrolmentInfo.dueDate'
                        }
                    },
                    {
                        range: {
                            'currentEnrolmentInfo.dueDate': {
                                lte: 'now'
                            }
                        }
                    },
                    {
                        terms: {
                            contentType: [__enums_1.ContentTypeEnum.OFFER, __enums_1.ContentTypeEnum.CHECKPOINT, __enums_1.ContentTypeEnum.ILT]
                        }
                    }
                ]
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    }
};
function parseContentVersionLogMetricElasticsearchResult(results) {
    const buckets = results.aggregations.counters.buckets;
    const contentVersionLogMetrics = buckets.map(doc => {
        return {
            enrolmentVersionId: doc.key,
            totalLearnersCount: doc.doc_count || 0,
            totalContents: doc.totalCount.value || 0,
            totalInProgress: doc.inProgress.count.value || 0,
            totalOverdue: doc.overdue.count.value || 0,
            totalComplete: doc.complete.count.value || 0,
            totalCheckpoints: doc.checkpoint.count.value || 0,
            totalLiveTrainings: doc.liveTraining.count.value || 0,
            totalCourses: doc.offer.count.value || 0,
            totalPaths: doc.curriculumOffer.count.value || 0,
            totalNotStarted: doc.notStarted.count.value || 0
        };
    });
    return contentVersionLogMetrics;
}
function getContentVersionLogMetrics(contentVersionLogs, stateFilters) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (contentVersionLogs.length === 0) {
            return [];
        }
        const stateQuery = {
            bool: {
                must: [
                    {
                        term: {
                            deleted: {
                                value: false
                            }
                        }
                    },
                    {
                        terms: {
                            enrolmentVersionId: contentVersionLogs.map(doc => doc.versionId)
                        }
                    },
                    {
                        terms: {
                            contentId: contentVersionLogs.map(doc => doc.contentId)
                        }
                    }
                ]
            }
        };
        if (stateFilters) {
            const query = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(stateFilters);
            Object.keys(query.bool).map(type => {
                if (stateQuery.bool[type]) {
                    stateQuery.bool[type] = concat_1.default(query.bool[type], stateQuery.bool[type]);
                }
                else {
                    stateQuery.bool[type] = query.bool[type];
                }
            });
        }
        const metricsQuery = {
            query: stateQuery,
            aggs: {
                counters: {
                    terms: {
                        field: 'enrolmentVersionId',
                        size: contentVersionLogs.length
                    },
                    aggs: StateMetricAggregation
                }
            }
        };
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(__elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL);
        const elasticsearchResults = yield elasticsearchClient.search({
            index: __enums_1.ElasticsearchIndicesEnum.STATE,
            type: __enums_1.ElasticsearchTypesEnum.STATE,
            size: 0,
            body: metricsQuery
        });
        return parseContentVersionLogMetricElasticsearchResult(elasticsearchResults);
    });
}
exports.getContentVersionLogMetrics = getContentVersionLogMetrics;
//# sourceMappingURL=getContentVersionLogMetrics.js.map